<div class="container">
  @for (language of languages; track language) {
    <mat-form-field class="language-text">
      <mat-label>{{ getLanguageTextLabel(language) }}</mat-label>
      <input
        matInput
        [ngModel]="getLanguageText(language)"
        (ngModelChange)="onTextChange($event, language)" />
    </mat-form-field>
  }
</div>
